export default __webpack_public_path__ + "static/media/hot_dogs_stand.d2a51f32.jpg";